import { t } from '../../app/i18n';

// new enumerator for filter based on loan attributes
export default {
    ZPS: 'ZPS', // Ziadost o Predcasne Splatenie
}

export const translation = {
    ZPS: t('Žiadosť o predčasné splatenie'),
}


// WEBPACK FOOTER //
// ./src/common/enums/loanAttributes.js